import React, { Component, PropTypes } from 'react';
import Form, { FormBody, FormActions, TextInput } from './Form';
import { auth } from '../actions/api';
import pjson from '../../package.json'
import ReCAPTCHA from "react-google-recaptcha";
import Cookies from 'js-cookie';
import Button from './Form/Button';

class Login extends Component {
  constructor(props) {
    super(props);

    this.state = {
      username: '',
      password: '',
      captcha: null,
      invalidAttempts: 0,
      isLoading: false,
    };

    this.onChangeUsername = this.onChange.bind(this, 'username');
    this.onChangePassword = this.onChange.bind(this, 'password');
    this.handleLogin = this.handleLogin.bind(this);
  }

  captchaRef;

  onChange(field, e) {
    this.setState({
      [field]: e.target.value,
    });
  }

  onChangeCaptcha = value => this.setState({ captcha: value });

  handleLogin(e) {
    e.preventDefault();

    const { username, password, captcha } = this.state;

    this.setState({ isLoading: true });
    auth
      .login(username, password, captcha)
      .then(() => {
        this.context.router.replace('/');
        window.location.reload();
      })
      .catch((err) => {
        console.log('login err', err);
        this.setState({ invalidAttempts: +this.state.invalidAttempts + 1 });
        this.captchaRef && this.state.invalidAttempts > 3 && this.captchaRef.reset();
        if (err.message) {
          if (err.message === 'Cant Login') this.setState({ invalidAttempts: 5 });
          alert(err.message);
        }
      })
      .finally(() => {
        this.setState({ isLoading: false });
      });
  }

  render() {
    // let cookie = document.cookie.split(';').reduce((acc, item) => {
    //   let kv = item.trim().split('=');
    //   return Object.assign(acc, {[kv[0]]: kv[1]})
    // }, {});
    const cookie = Cookies.get('app_config');
    let app_config = !!cookie && JSON.parse(cookie);

    return (
      <div className="Login">
        <h3>{(app_config && app_config.app_title) || 'WSCADA'}</h3>
        {(app_config && <p>{app_config.organization_name}</p>)}

        <div className="loginForm">
          <Form>
            <FormBody>
              <TextInput value={this.state.username} onChange={this.onChangeUsername} placeholder={'Username'} />
              <TextInput type="password" placeholder={'Password'} value={this.state.password} onChange={this.onChangePassword} />
              {this.state.invalidAttempts > 3 &&
                <ReCAPTCHA ref={c => this.captchaRef = c} style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center' }}
                  sitekey="6LcS28MUAAAAALgxq9pMnMBqGepfalO78vfr264K"
                  onChange={this.onChangeCaptcha}
                />}
            </FormBody>
            <FormActions>
              {/* <button className="right" onClick={this.handleLogin}>Login</button> */}
              <Button label='Login' onClick={this.handleLogin} className='right' isLoading={this.state.isLoading} />
            </FormActions>
          </Form>
        </div>
        <div>
          <small>{(app_config && app_config.app_version) || pjson.version}</small>
        </div>
      </div>
    );
  }
}

Login.contextTypes = {
  router: PropTypes.shape().isRequired,
};

export default Login;



// WEBPACK FOOTER //
// ./src/components/Login.js